import * as R from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { GetRolesResponse } from "../api";
import { ActionType, AppDispatch, RootState } from "../reducer";
import { UserRole } from "../types/app";

export const useRoles: () => [UserRole[], (roles: UserRole[]) => void] = () => {
  const roles = useSelector((state: RootState) => state.settings.roles);
  const dispatch = useDispatch<AppDispatch>();
  const setRoles = (roles: UserRole[]) =>
    dispatch({ type: ActionType.SET_ROLES, roles });
  return [roles, setRoles];
};

export enum Roles {
  OWNER = "Owner",
  ADMIN = "Admin",
}

export const useUserIsOwner: () => boolean = () => {
  const [roles, setRoles] = useRoles();
  return R.any((role) => role.role === Roles.OWNER, roles);
};

// Mirrors useUserIsOwner but checks the per-app role (roles are refetched
// whenever the active appId changes, see useFetchAppDataListener), matching
// the backend Qo.Perm "manage-members" capability's Admin case.
export const useUserIsAppAdmin: () => boolean = () => {
  const [roles] = useRoles();
  return R.any((role) => role.role === Roles.ADMIN, roles);
};

export const useHandleGetRolesResponse: () => (
  reponse: GetRolesResponse
) => void = () => {
  const [roles, setRoles] = useRoles();
  return (response) => {
    setRoles(response.roles);
  };
};
